import { render } from "./MenuTechnologyItem.vue?vue&type=template&id=b5f56a1e&scoped=true"
import script from "./MenuTechnologyItem.vue?vue&type=script&lang=js"
export * from "./MenuTechnologyItem.vue?vue&type=script&lang=js"

import "./MenuTechnologyItem.vue?vue&type=style&index=0&id=b5f56a1e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/space-tourism-website-main-VueJs/cli-version/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5f56a1e"]])

export default __exports__